// Config variables + LLM config — extracted from api.js (Tier 2 #9a round 3).
// Org-level config variables, per-app config variables, the
// {{env.X}}/{{config.X}} placeholder scanner, and the global LLM config.

import api from './api';

// ─── Org Config Variables ──────────────────────────────────────────────────
export const fetchConfigVariables = async (orgId) => {
  const response = await api.get(`/orgs/${orgId}/config`);
  return response.data;
};

export const createConfigVariable = async (orgId, data) => {
  const response = await api.post(`/orgs/${orgId}/config`, data);
  return response.data;
};

export const updateConfigVariable = async (orgId, varId, data) => {
  const response = await api.put(`/orgs/${orgId}/config/${varId}`, data);
  return response.data;
};

export const deleteConfigVariable = async (orgId, varId) => {
  const response = await api.delete(`/orgs/${orgId}/config/${varId}`);
  return response.data;
};

// Resolves one secret's actual value on demand — the list response never
// carries it. Gated by a separate permission from config read/write; every
// call is audited server-side.
export const revealConfigVariable = async (orgId, varId) => {
  const response = await api.get(`/orgs/${orgId}/config/${varId}/reveal`);
  return response.data;
};

// ─── App Config Variables (frozen, read-only) ──────────────────────────────
// Config variables moved to org scope (see
// docs/platform/config-variables-org-consolidation-spec.md §4.2, §4.5, D11,
// D7). Only the read is kept — it's the cutover verification surface and
// rollback evidence. Create/update/delete no longer exist for app scope.
export const fetchAppConfigVariables = async (appId, { signal } = {}) => {
  const response = await api.get(`/apps/${appId}/config-vars`, { signal });
  return response.data;
};

// Scans the app's templates + integrations for {{env.X}} placeholders and
// reports which aren't satisfied by app- or org-level env config variables.
export const scanAppEnvVariables = async (appId) => {
  const response = await api.get(`/apps/${appId}/config-vars/scan`);
  return response.data;
};

// ─── LLM Config ────────────────────────────────────────────────────────────
export const fetchLLMConfig = async () => {
  const response = await api.get("/llm-config");
  return response.data;
};

export const updateLLMConfig = async (data) => {
  const response = await api.put("/llm-config", data);
  return response.data;
};

// Model catalog (proxied from llm-gateway). Returns { providers, models }.
// Only models whose provider has a configured key are returned by default.
export const fetchLLMModels = async (params = {}) => {
  const response = await api.get("/llm-models", { params });
  return response.data;
};
